document.addEventListener('DOMContentLoaded', function() {
  // Mobile search button toggle.
  // eslint-disable-next-line max-len
  const mobileSearchButton = document.querySelector('.site-header__controllers--mobile .icon-magnifier');

  mobileSearchButton.addEventListener('click', (event) => {
    event.preventDefault();

    const searchBox = document.querySelector('.search-box');
    searchBox.classList.toggle('search-box--open');
  });

  const burger = document.querySelector('.burger');
  burger.addEventListener('click', function() {
    const navElements = document.querySelector(
      '.site-header .navigation__elements'
    );

    if (window.getComputedStyle(navElements).display === 'block') {
      navElements.style.display = 'none';
    }
    else {
      navElements.style.display = 'block';
    }

    if (this.classList.contains('is-active')) {
      burger.classList.remove('is-active');
    }
    else {
      burger.classList.add('is-active');
    }
  });
});
